// ============================================================================
// HOOK: useProcessDossier — v1.0 — Passo 34 (Dossiê do Processo)
// Query reativa (onSnapshot) de todos os cadernos de autos agrupados
// pelo mesmo ancestry.primary_process_id (NPU ou apelido pré-processual).
// ============================================================================

import { useEffect, useState } from 'react';
import { subscribeProcessDossier } from '../services/ProcessDossierRepository';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export function useProcessDossier(primaryProcessId) {
  const [workspaces, setWorkspaces] = useState([]);
  const [loading, setLoading]       = useState(false);
  const [error, setError]           = useState(null);

  useEffect(() => {
    const pid = String(primaryProcessId || '').trim();
    if (!pid || !appId) {
      setWorkspaces([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    const unsub = subscribeProcessDossier(
      pid,
      appId,
      (snap) => {
        const items = snap.docs
          .map((d) => ({ id: d.id, ...(d.data() || {}) }))
          .sort((a, b) => {
            const av = a?.updatedAt?.toDate ? a.updatedAt.toDate().getTime() : 0;
            const bv = b?.updatedAt?.toDate ? b.updatedAt.toDate().getTime() : 0;
            return bv - av;
          });
        setWorkspaces(items);
        setLoading(false);
      },
      (err) => {
        setError(String(err?.message || err));
        setLoading(false);
      }
    );

    return () => unsub();
  }, [primaryProcessId]);

  return { workspaces, loading, error };
}
